import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "buttons": _vm.buttons,
      "offset": "20"
    },
    on: {
      "addItem": _vm.addItem
    }
  }, [_c(VDialog, {
    attrs: {
      "width": "75%",
      "max-width": "600"
    },
    model: {
      value: _vm.showPreviewDialog,
      callback: function ($$v) {
        _vm.showPreviewDialog = $$v;
      },
      expression: "showPreviewDialog"
    }
  }, [_c('div', [_c(VImg, {
    staticClass: "grey darken-4",
    attrs: {
      "src": _vm.imagePreviewUrl,
      "max-width": "100%",
      "contain": ""
    },
    on: {
      "load": _vm.imagePreviewLoaded
    }
  })], 1)]), _c(VRow, {
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, [_c('div', {
    staticClass: "attachHeader"
  }, [_vm._t("headline", function () {
    return [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.attachmentHeadline')))])];
  }), _c('div', {
    staticClass: "hiddenInput"
  }, [!_vm.disabled ? _c('input', {
    ref: "attachmentInput",
    staticClass: "upload",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "accept": _vm.accept,
      "type": "file",
      "name": "image",
      "multiple": ""
    },
    on: {
      "change": _vm.fileInputChanged,
      "click": _vm.fileInputClicked
    }
  }) : _vm._e()])], 2), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm.attachmentsInternal.length || _vm.uploads.length ? [_vm._l(_vm.attachmentsInternal, function (item) {
    return [_c('core-dtwin-attachments-item', {
      key: item.id || item.storagePath,
      staticClass: "mb-2",
      attrs: {
        "source": _vm.source,
        "disabled": _vm.disabled,
        "item": item,
        "isImage": _vm.isImage(item),
        "api-version": _vm.apiVersion
      },
      on: {
        "item:remove": _vm.removeHandler,
        "item:preview": _vm.previewHandler,
        "item:selected": _vm.itemSelected,
        "item:deselected": _vm.itemDeselected
      }
    })];
  }), _vm._l(_vm.uploads, function (item) {
    return [_c('core-dtwin-attachments-item', {
      key: item.id || item.storagePath,
      staticClass: "mb-2",
      attrs: {
        "source": _vm.source,
        "disabled": _vm.disabled,
        "item": item,
        "api-version": _vm.apiVersion
      },
      on: {
        "item:update": _vm.updateHandler
      }
    })];
  }), _vm._l(_vm.queue, function (item) {
    return [_c('core-dtwin-attachments-item', {
      key: item.id || item.storagePath,
      staticClass: "mb-2",
      attrs: {
        "source": _vm.source,
        "disabled": _vm.disabled,
        "isQueued": true,
        "item": item,
        "api-version": _vm.apiVersion
      }
    })];
  })] : _vm._e(), !_vm.attachmentsInternal.length && !_vm.uploads.length ? [_c('tr', [_c('td', {
    attrs: {
      "span": "3"
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n                  " + _vm._s(_vm.source === 'digitaltwin' ? _vm.$i18n_t('DigitalTwin.DigitalTwin.attachmentEmptyState') : _vm.$i18n_t('DigitalTwin.DigitalTwin.attachmentEmptyStateGeneric')) + "\n                ")])])])] : _vm._e()], 2)]), _c('p', {
    staticClass: "errorMessage"
  }, [_vm.errorMessage ? _c('span', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])], 1), _vm.$slots.additional ? _c(VRow, {
    staticClass: "mt-4 mb-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c(VCol, [_vm._t("additional")], 2)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };